import React from 'react';
import { Paper, Grid, TextField, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const SearchBar = ({ searchTerm, onSearchTermChange, onClear, t }) => {
  const theme = useTheme();

  return (
    <Paper sx={{ p: 2, mb: 2.5, borderRadius: theme.shape.borderRadius }} elevation={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <TextField
            fullWidth
            name="searchTerm"
            label={t("searchReports")}
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={onSearchTermChange}
            autoComplete="off"
            inputProps={{ autoCorrect: "off", autoCapitalize: "none", spellCheck: false }}
            placeholder={t("searchPlaceholder", "Date (dd.mm.yyyy, dd.mm, yyyy), operator, maker, model...")}
            helperText={t("searchHelp", "Search by date (dd.mm.yyyy, dd.mm, dd/mm/yyyy, dd/mm), operator, maker, model, or any text")}
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" color="action" /></InputAdornment>,
              endAdornment: searchTerm && <InputAdornment position="end"><IconButton size="small" onClick={onClear}><ClearIcon fontSize="small" /></IconButton></InputAdornment>
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SearchBar;
